import { render, staticRenderFns } from "./MatchMaking.vue?vue&type=template&id=3c80d1b3&scoped=true"
import script from "./MatchMaking.vue?vue&type=script&lang=js"
export * from "./MatchMaking.vue?vue&type=script&lang=js"
import style0 from "./MatchMaking.vue?vue&type=style&index=0&id=3c80d1b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c80d1b3",
  null
  
)

export default component.exports